import AppCoursetypesIndex from "./courseType.vue";
import AppCoursetypesList from "./list/list.vue";
import AppCoursetypesItem from "./item/item.vue";

const routes = [
  {
    path: "courseType",
    component: AppCoursetypesIndex,
    meta: {
      auth: {
        roles: "courseType.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "courseType.index",
        component: AppCoursetypesList,
        meta: {
          auth: {
            roles: "courseType.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "courseType.create",
        component: AppCoursetypesItem,
        meta: {
          auth: {
            roles: "courseType.create",
            redirect: { name: "courseType.index" }
          }
        }
      },
      {
        path: ":id",
        name: "courseType.edit",
        component: AppCoursetypesItem,
        meta: {
          auth: {
            roles: "courseType.update",
            redirect: { name: "courseType.index" }
          }
        }
      }
    ]
  }
];

export default routes;
